import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Star } from "lucide-react";

export const ProductCard = ({ product, index = 0, large = false }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 18 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.45, delay: (index % 6) * 0.06 }}
      className="group"
    >
      <Link
        to={`/product/${product.id}`}
        data-testid={`product-card-${product.id}`}
        className="block border border-obsidian/15 bg-white transition-shadow duration-200 hover:shadow-[6px_6px_0px_#0A0A0A]"
      >
        <div className={`relative overflow-hidden bg-secondary ${large ? "aspect-[16/10]" : "aspect-[4/3]"}`}>
          <img
            src={product.image}
            alt={product.title}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute left-0 top-0 bg-obsidian px-3 py-1.5 text-[10px] font-semibold uppercase tracking-[0.2em] text-white">
            {product.category}
          </span>
        </div>
        <div className="flex items-start justify-between gap-4 p-5">
          <div>
            <h3 className="font-serif text-xl font-medium tracking-tight text-obsidian">
              {product.title}
            </h3>
            <p className="mt-1 text-sm text-obsidian/55">{product.tagline}</p>
            {product.rating_count > 0 && (
              <div className="mt-2 flex items-center gap-1 text-signal">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className={`h-3.5 w-3.5 ${i < Math.round(product.rating_avg) ? "fill-signal" : "fill-none text-obsidian/25"}`} />
                ))}
                <span className="ml-1 text-xs text-obsidian/45">({product.rating_count})</span>
              </div>
            )}
          </div>
          <div className="shrink-0 text-right">
            <div className="font-serif text-2xl tracking-tighter text-obsidian">${product.price}</div>
            <div className="text-[10px] uppercase tracking-[0.15em] text-obsidian/40">{product.file_format}</div>
          </div>
        </div>
      </Link>
    </motion.div>
  );
};
